import React, { useCallback, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { CheckOutlined } from "@ant-design/icons";
import { Button, Modal, Table, Tooltip } from "antd";
import { getGroupsForRoleById2 } from "../../actions/api";

const GroupInRoleSearch = ({
  title,
  buttonText,
  applicationId,
  roleId,
  onSelect,
  icon,
}) => {
  const [visible, setVisible] = useState(false);
  const [searchIsLoading, setSearchIsLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const dispatch = useDispatch();

  const modalColumns = [
    {
      title: "Name",
      dataIndex: "displayName",
    },
    {
      title: "Action",
      dataIndex: "id",
      render: function ActionButton(_, record) {
        return (
          <Button
            onClick={() => handleSelect(record)}
            icon={<CheckOutlined />}
          />
        );
      },
    },
  ];

  const handleSelect = (record) => {
    onSelect(record);
    setVisible(false);
  };

  const openUpdateModal = (e) => {
    e.preventDefault();
    setVisible(true);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const fetchStatus = useCallback(async () => {
    if (roleId) {
      setSearchIsLoading(true);
      const tmpSettings = await dispatch(
        getGroupsForRoleById2(applicationId, roleId),
      );
      if (tmpSettings && tmpSettings.payload && tmpSettings.payload.data)
        setDataSource(tmpSettings.payload.data);
      setSearchIsLoading(false);
    }
  }, [dispatch, applicationId, roleId]);

  useEffect(() => {
    if (visible) fetchStatus();
  }, [fetchStatus, visible]);

  return (
    <>
      <Tooltip title={title}>
        <Button
          id="searchWithModal"
          onClick={openUpdateModal}
          icon={icon}
          disabled={roleId ? false : true}
        >
          {buttonText}
        </Button>
      </Tooltip>
      <Modal
        style={{ minWidth: "90%" }}
        centered
        title={title}
        open={visible}
        onOk={handleCancel}
        okText="Close"
        onCancel={handleCancel}
        confirmLoading={searchIsLoading}
      >
        <Table
          style={{ marginTop: "10px" }}
          loading={searchIsLoading}
          rowKey="id"
          pagination={{
            pageSize: 10,
          }}
          columns={modalColumns}
          dataSource={dataSource}
        />
      </Modal>
    </>
  );
};

GroupInRoleSearch.propTypes = {
  onSelect: PropTypes.func.isRequired,
  applicationId: PropTypes.string.isRequired,
  roleId: PropTypes.string,
  title: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  icon: PropTypes.object,
};

export default connect(() => ({}), {})(GroupInRoleSearch);
